
import { Component, Vue } from "vue-property-decorator";
import { namespace } from 'vuex-class';

const Mobile = namespace("mobile");

@Component
export default class EnableGPSButton extends Vue {
    @Mobile.Mutation setManualLocationUpdate: (flag: boolean) => void;
}
